// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

import { createElement, Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon, disableDocumentScroll, enableDocumentScroll } from '@plesk/ui-library';

const hasScroll = () => document.documentElement.style.position !== 'fixed';

const disableScroll = () => {
    if (hasScroll()) {
        disableDocumentScroll();
    }
};

const enableScroll = () => {
    if (!hasScroll()) {
        enableDocumentScroll();
    }
};

class Overlay extends Component {
    state = {
        isReady: false,
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeydown);
    }

    componentDidUpdate(prevProps) {
        const { isOpen } = this.props;

        if (!prevProps.isOpen && isOpen) {
            this.clearAllTimeouts();
            this.readyTimeout = setTimeout(() => {
                this.setState({
                    isReady: true,
                });
                this.enterTimeout = setTimeout(() => {
                    disableScroll();
                }, 500);
            }, 100);
        } else if (prevProps.isOpen && !isOpen) {
            this.clearAllTimeouts();
            this.exitTimeout = setTimeout(() => {
                this.setState({ isReady: false });
                enableScroll();
            }, 500);
        }
    }

    componentWillUnmount() {
        this.clearAllTimeouts();
        enableScroll();
        document.removeEventListener('keydown', this.handleKeydown);
    }

    clearAllTimeouts = () => {
        clearTimeout(this.readyTimeout);
        clearTimeout(this.enterTimeout);
        clearTimeout(this.exitTimeout);
    };

    readyTimeout = null;

    enterTimeout = null;

    exitTimeout = null;

    handleKeydown = e => {
        const { onCancel } = this.props;
        if (e.keyCode === 27) {
            onCancel();
        }
    };

    render() {
        const { isOpen, onCancel, children } = this.props;
        const { isReady } = this.state;

        if (!isOpen && !isReady) {
            return null;
        }

        return createPortal(
            <div
                className={classNames('cookie-policy-overlay', {
                    'cookie-policy-overlay--enter': isOpen && isReady,
                    'cookie-policy-overlay--exit': !isOpen && isReady,
                })}
            >
                <div className="cookie-policy-overlay__modal">
                    <a onClick={onCancel} className="cookie-policy-overlay__modal-close">
                        <Icon name="cross-mark" />
                    </a>
                    <div className="cookie-policy-overlay__modal-content">
                        <div className="cookie-policy-overlay__modal-inner">{children}</div>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

Overlay.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default Overlay;



// WEBPACK FOOTER //
// ./app/cookie-policy/Preferences/Overlay.js